// extracted by mini-css-extract-plugin
module.exports = {"container":"GlobalFilter_container__dNsLu","active":"GlobalFilter_active__3Tb_J"};